import { render, staticRenderFns } from "./SendAlert.vue?vue&type=template&id=ab5a783e"
import script from "./SendAlert.ts?vue&type=script&lang=ts&external"
export * from "./SendAlert.ts?vue&type=script&lang=ts&external"
import style0 from "./SendAlert.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports